import type { PillProps } from 'ext-ui/components/Pill/Pill'
import moment from 'moment-timezone'
import type { BillPaymentDisplayStatus } from 'src/queries/payments/payments.types'

const STATUS_PRESENTATION: Record<
  BillPaymentDisplayStatus,
  { label: string; color?: PillProps['color'] }
> = {
  ACTION_REQUIRED: { label: 'Action Required', color: 'severe' },
  PROCESSING: { label: 'Processing', color: 'pending' },
  COMPLETED: { label: 'Completed', color: 'highlight' },
  FAILED: { label: 'Failed', color: 'severe' },
  RETURNED: { label: 'Returned', color: 'severe' },
  CANCELLED: { label: 'Cancelled' },
}

export const paymentStatusPresentation = (
  status: BillPaymentDisplayStatus,
): { label: string; color?: PillProps['color'] } => STATUS_PRESENTATION[status]

export const formatPaymentHistoryDate = (value: string | null): string =>
  value ? moment(value, 'YYYY-MM-DD', true).format('MMM D, YYYY') : '—'

export const formatPaymentAmount = (
  amountCents: number,
  currency: string,
): string =>
  new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency,
  }).format(amountCents / 100)
